/**
 * JSON schema version inside stored documents (`__meta.schemaVersion`).
 * LocalStorage keys intentionally omit a `.v1` suffix so the same JSON can map 1:1 to API fields:
 * - `kronos.user.<userId>` → future `users.config`
 * - `kronos.user.<userId>.instance.<instanceId>` → future user↔instance junction `config`
 * Document fields: `analysesStatsDateUi`, `analysesStatsVenueUi`, `kUserSettings`,
 * `listTablesSortState` (per-table `sortState`), instance-scoped `screening`, `stats`,
 * `bucketSimulator`, `healthCheckResumeSnooze`, `screeningsFiltersUi`, etc.
 */
export const KRONOS_PREFS_SCHEMA_VERSION = 1;

/** Whole JSON value maps to future API `users.config`. */
export const userPrefsStorageKey = (userId) =>
    `kronos.user.${userId || 'anonymous'}`;

/** Whole JSON value maps to future API user↔instance junction `config`. */
export const userInstancePrefsStorageKey = (userId, instanceId) =>
    `kronos.user.${userId || 'anonymous'}.instance.${instanceId || 'none'}`;
